import React from "react";
import { Table } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { DevIcons } from "./DevDashboardIcons";
import { commonservices } from "../../services/CommonServices";
import degrees360Icon from "../../assets/images/360-degrees.svg";

const DevMachinePortfolioTable = ({ initialRows = [], tableHeight }) => {
  const navigate = useNavigate();

  // Navigation handlers
  const fnMachine360 = (machine_id, item) => {
    const rawRefMachineId =
      item?.refmachineid ??
      item?.refMachineId ??
      item?.rawItem?.refmachineid ??
      item?.rawItem?.refMachineId;

    const numRefId = Number(rawRefMachineId);

    const mId =
      machine_id !== undefined && machine_id !== null && machine_id !== ""
        ? machine_id
        : item?.machineid ??
          item?.id ??
          item?.machineId ??
          item?.MachineId ??
          item?.machinename;

    // If refmachineid is more than 0 then pass refmachineid, otherwise if refmachineid is 0 or lower than 0 then pass machineid
    const rawId = !isNaN(numRefId) && numRefId > 0 ? numRefId : mId;

    if (rawId === undefined || rawId === null || rawId === "") return;

    try {
      const encrypted = commonservices.bodyEncryption(String(rawId));
      navigate(`/marketplace/machine-360/${encrypted}/my machine`, {
        state: { machineData: item },
      });
    } catch (e) {
      console.error("fnMachine360 navigation error", e);
      navigate(`/marketplace/machine-360/${rawId}/my machine`, {
        state: { machineData: item },
      });
    }
  };

  const fnMachineDetail = (machine_id, item) => {
    const rawId =
      machine_id !== undefined && machine_id !== null && machine_id !== ""
        ? machine_id
        : item?.machineid ??
          item?.id ??
          item?.machineId ??
          item?.MachineId ??
          item?.refmachineid ??
          item?.machinename;

    if (rawId === undefined || rawId === null || rawId === "") return;

    try {
      const encrypted = commonservices.bodyEncryption(String(rawId));
      navigate(`/marketplace/marketplace-detail/${encrypted}/my machine`, {
        state: { machineData: item },
      });
    } catch (e) {
      console.error("fnMachineDetail navigation error", e);
      navigate(`/marketplace/marketplace-detail/${rawId}/my machine`, {
        state: { machineData: item },
      });
    }
  };

  const rows = initialRows || [];
  const totalCount = rows.length;

  return (
    <div
      className="dev-portfolio-card"
      style={
        tableHeight
          ? {
              height: `${tableHeight}px`,
              maxHeight: `${tableHeight}px`,
              minHeight: `${tableHeight}px`,
            }
          : undefined
      }
    >
      {/* Header with Title only (filters removed as requested) */}
      <div className="dev-portfolio-header">
        <h3 className="dev-portfolio-title">
          Machine Portfolio <span className="dev-portfolio-count">({totalCount})</span>
        </h3>
      </div>

      {/* Scrollable Table matching Image 2 columns */}
      <div className="dev-table-container">
        <Table className="dev-portfolio-table mb-0">
          <thead>
            <tr>
              <th>Machine Name</th>
              <th>Industry</th>
              <th>Category</th>
              <th>Created On</th>
              <th>Version</th>
              <th>Ratings</th>
              <th className="text-center">Total Workflow</th>
              <th className="text-center">Results</th>
              <th>Usages</th>
              <th className="text-center">Machine 360</th>
            </tr>
          </thead>
          <tbody>
            {rows.length > 0 ? (
              rows.map((row, idx) => (
                <tr key={row.machineId || row.id || idx}>
                  <td>
                    <span
                      className="dev-table-machine-name"
                      onClick={() => fnMachineDetail(row.machineId, row.rawItem || row)}
                      title={row.machineName}
                    >
                      {row.machineName}
                    </span>
                  </td>
                  <td className="text-secondary">{row.industry || "-"}</td>
                  <td className="text-secondary">{row.category || "-"}</td>
                  <td className="text-secondary text-nowrap">{row.createdOn || "-"}</td>
                  <td>
                    <div className="d-inline-flex align-items-center">
                      <span className="dev-table-version">{row.version || "1.0.0"}</span>
                      {(Number(row.versioncount ?? row.versionCount) || 1) > 1 && (
                        <span
                          className="dev-version-badge"
                          title={`${row.versioncount ?? row.versionCount} versions`}
                        >
                          +{(Number(row.versioncount ?? row.versionCount) || 1) - 1}
                        </span>
                      )}
                    </div>
                  </td>
                  <td>
                    <div className="dev-table-rating">
                      <DevIcons.Star
                        size={14}
                        color="#f59e0b"
                        fill="#f59e0b"
                      />
                      <span>
                        {row.rating}{" "}
                        <span className="text-muted">({row.ratingCount})</span>
                      </span>
                    </div>
                  </td>
                  <td className="text-center">{row.workflows}</td>
                  <td className="text-center text-nowrap">
                    <span className="text-results-success">
                      {row.machinesuccesscount ?? row.successCount ?? 0}
                    </span>
                    <span className="text-results-slash">/</span>
                    <span className="text-results-failed">
                      {row.machinefailedcount ?? row.failedCount ?? 0}
                    </span>
                  </td>
                  <td className="text-secondary text-nowrap">
                    {row.totalusagetime || row.usages || "00:00 min"}
                  </td>
                  <td className="text-center">
                    <button
                      type="button"
                      className="machine-360-table-btn"
                      title="Machine 360"
                      aria-label="Machine 360"
                      onClick={(e) => {
                        e.stopPropagation();
                        const refId = Number(
                          row.refmachineid ??
                          row.refMachineId ??
                          row.rawItem?.refmachineid ??
                          row.rawItem?.refMachineId
                        );
                        const targetId =
                          !isNaN(refId) && refId > 0
                            ? refId
                            : (row.machineId ?? row.rawItem?.machineid);
                        fnMachine360(targetId, row.rawItem || row);
                      }}
                    >
                      <img
                        src={degrees360Icon}
                        alt="360 View"
                        className="machine-360-btn-icon"
                      />
                    </button>
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan={10} className="text-center py-4 text-muted">
                  No matching machines found.
                </td>
              </tr>
            )}
          </tbody>
        </Table>
      </div>
    </div>
  );
};

export default DevMachinePortfolioTable;
